import { CartItem } from './cartItem';
import { Shipping } from './shipping';
import { ShippingOption } from './shippingOption';

export interface CheckoutItem {
    id: number;
    cartItem: CartItem;
    product_id: string;
    quantity: number;
    price: number;
    priceO: number;
    totalLinea: number;
    totalLineaSinDescuento: number;
    shipping: Shipping;
    shippingOptions: ShippingOption[];
    shippingOptionSelected: ShippingOption;
    shippingId: string;
    primary: boolean;
    group: number;
    parts: boolean;
    json: string;
    portesTipoEntrega: number;
}


export class CheckoutItemHelper {

    static create(): CheckoutItem {
        return {
            id :  0,
            cartItem : null,
            product_id : '',
            quantity : 0,
            price : 0,
            priceO : 0,
            totalLinea: 0,
            totalLineaSinDescuento: 0,
            shipping : null,
            shippingOptions : [],
            shippingId : '',
            shippingOptionSelected : null,
            primary : true,
            group : 0,
            parts: false,
            json:'',
            portesTipoEntrega: 0,
        };
    }

    static getShippingOptionSelectedById(checkItem: CheckoutItem, id: string): ShippingOption {
        for (const shipping of checkItem.shippingOptions) {
            if (shipping.id === id) {
                return shipping;
            }
        }
        return null;
    }

    static getDto(checkItem: CheckoutItem): number {
        // TODO: @fabiano poner descuento
        // return checkItem.quantity * (checkItem.price * checkItem.shippingOptionSelected.descuento / 100);
        return 0;
    }
    static getDtoNeto(checkItem: CheckoutItem): number {
        // TODO: @fabiano poner descuento
        // return checkItem.price * checkItem.shippingOptionSelected.descuento / 100;
        return 0;
    }
    static getBruto(checkItem: CheckoutItem): number {
        return (checkItem.priceO * checkItem.quantity);
    }
    static getNeto(checkItem: CheckoutItem): number {
        return checkItem.priceO - CheckoutItemHelper.getDtoNeto(checkItem);
    }
    static getTotal(checkItem: CheckoutItem): number {
        return CheckoutItemHelper.getBruto(checkItem) - CheckoutItemHelper.getDto(checkItem);
    }
}
